import {
  HubFilter,
  HubFilterOption,
} from '@/shared/components/filter/hub-filter';
import {
  createHubFilterStore,
  useGenericActiveProjectHubFilterCount,
  useGenericHasProjectHubFilters,
} from '@/shared/hooks/use-hub-filter-store';

export const useNotificationHubFilterStore = createHubFilterStore();
export const useActiveNotificationHubFilterCount = () =>
  useGenericActiveProjectHubFilterCount(useNotificationHubFilterStore());
export const useHasNotificationHubFilters = () =>
  useGenericHasProjectHubFilters(useNotificationHubFilterStore());

export const NotificationHubFilter = () => {
  return (
    <HubFilter
      {...useNotificationHubFilterStore()}
      activeCount={() => useActiveNotificationHubFilterCount()}
      options={[
        {
          option: HubFilterOption.NOTIFICATION_STATUS,
          allowMultiple: false,
        },
        {
          option: HubFilterOption.NOTIFICATION_TYPE,
        },
        {
          option: HubFilterOption.NOTIFICATION_CATEGORY,
        },
        {
          option: HubFilterOption.FILTER_RANGE,
        },
        {
          option: HubFilterOption.PROJECT,
          allowMultiple: false,
        },
        {
          option: HubFilterOption.SUBPROJECT,
          allowMultiple: false,
        },
        {
          option: HubFilterOption.PARTNER,
        },
        {
          option: HubFilterOption.ROLE,
        },
      ]}
    />
  );
};
